var exports = {
  "d5": "xa15a2ab7--5e17cc--head",
  "DD": "xa15a2ab7--5e17cc--title",
  "rf": "xa15a2ab7--5e17cc--body",
  "z3": "xa15a2ab7--5e17cc--error",
  "DG": "xa15a2ab7--5e17cc--error--visible",
  "Z1": "xa15a2ab7--5e17cc--error--hide",
};

module.exports = exports;
